// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActingMessage_root__KbN-L {
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-grow: 1;
  min-width: 1px;
  overflow: hidden;
}

.ActingMessage_content__tmDjV {
  margin: 4px 0;
}

.ActingMessage_icon__ZsC2G {
  width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 4px 0;
}

.ActingMessage_close__mHeBK {
  cursor: pointer;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transform: rotate(0deg);
  transition: 0.3s transform;
}
.ActingMessage_close__mHeBK:hover {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/NewMessagePanel/ActingMessage/ActingMessage.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EAEA,YAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EAEA,aAAA;AAfF;;AAkBA;EACE,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EACA,0BAAA;AAfF;AAiBE;EACE,yBAAA;AAfJ","sourcesContent":[".root {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n\n  flex-grow: 1;\n  min-width: 1px;\n  overflow: hidden;\n}\n\n//.content {\n//  padding: 8px 0;\n//  display: flex;\n//  flex-grow: 1;\n//  max-width: 100%;\n//  min-width: 1px;\n//  overflow: hidden;\n//  //text-overflow: ellipsis;\n//\n//  &>* {\n//    flex-shrink: 0;\n//  }\n//}\n\n.content {\n  margin: 4px 0;\n}\n\n.icon {\n  width: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  margin: 4px 0;\n}\n\n.close {\n  cursor: pointer;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transform: rotate(0deg);\n  transition: 0.3s transform;\n\n  &:hover {\n    transform: rotate(180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ActingMessage_root__KbN-L`,
	"content": `ActingMessage_content__tmDjV`,
	"icon": `ActingMessage_icon__ZsC2G`,
	"close": `ActingMessage_close__mHeBK`
};
export default ___CSS_LOADER_EXPORT___;
